import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Home,
  DollarSign,
  // Heart,
  // CheckSquare,
  // Star,
  // Users,
  Settings,
  Menu,
  X,
} from 'lucide-react';

const navItems = [
  { label: 'Home', icon: Home, path: '/', section: 'home' },
  { label: 'Finance', icon: DollarSign, path: '/finance/master-accounts', section: 'finance' },
  // { label: 'Health', icon: Heart, path: '/health/dashboard', section: 'health' },
  // { label: 'Productivity', icon: CheckSquare, path: '/productivity/habits', section: 'productivity' },
  // { label: 'Goals', icon: Star, path: '/life/bucket-list', section: 'life' },
  // { label: 'Network', icon: Users, path: '/network', section: 'network' },
];

export default function Sidebar() {
  const { pathname } = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const getActiveSection = () => {
    if (pathname === '/') return 'home';
    if (pathname.startsWith('/finance')) return 'finance';
    if (pathname.startsWith('/health')) return 'health';
    if (pathname.startsWith('/productivity')) return 'productivity';
    if (pathname.startsWith('/life')) return 'life';
    if (pathname.startsWith('/network')) return 'network';
    if (pathname.startsWith('/settings')) return 'settings';
    return 'home';
  };

  const activeSection = getActiveSection();

  const navLinkClasses = (section) =>
    `relative flex items-center justify-center w-10 h-10 rounded-lg transition-all duration-150 group ${
      activeSection === section
        ? 'bg-accent/15 text-accent'
        : 'text-text-muted hover:text-text-primary hover:bg-bg-tertiary/60'
    }`;

  const mobileNavLinkClasses = (section) =>
    `flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-150 ${
      activeSection === section
        ? 'bg-accent/15 text-accent font-medium'
        : 'text-text-secondary hover:text-text-primary hover:bg-bg-tertiary/60'
    }`;

  return (
    <>
      {/* Mobile header bar */}
      <div className="md:hidden flex items-center h-12 px-4 bg-bg-secondary border-b border-border/50 shrink-0">
        <button
          onClick={() => setMobileOpen(true)}
          className="text-text-muted hover:text-text-primary p-1"
        >
          <Menu className="w-5 h-5" />
        </button>
        <Link to="/" className="ml-3 flex items-center gap-2">
          <img src="/meridian-logo.png" alt="Meridian" className="w-6 h-6" />
          <span className="text-sm font-semibold text-text-primary">Meridian</span>
        </Link>
      </div>

      {/* Mobile slide-out overlay */}
      {mobileOpen && (
        <div className="md:hidden fixed inset-0 z-50 flex">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setMobileOpen(false)}
          />
          {/* Drawer */}
          <div className="relative w-64 bg-bg-secondary border-r border-border/50 flex flex-col">
            <div className="flex items-center justify-between h-12 px-4 border-b border-border/50">
              <div className="flex items-center gap-2">
                <img src="/meridian-logo.png" alt="Meridian" className="w-6 h-6" />
                <span className="text-sm font-semibold text-text-primary">Meridian</span>
              </div>
              <button
                onClick={() => setMobileOpen(false)}
                className="text-text-muted hover:text-text-primary p-1"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <nav className="flex-1 flex flex-col gap-1 p-3">
              {navItems.map(({ label, icon: Icon, path, section }) => (
                <Link
                  key={section}
                  to={path}
                  onClick={() => setMobileOpen(false)}
                  className={mobileNavLinkClasses(section)}
                >
                  <Icon className="w-[18px] h-[18px]" />
                  <span className="text-sm">{label}</span>
                </Link>
              ))}
            </nav>
            <div className="p-3 border-t border-border/50">
              <Link
                to="/settings"
                onClick={() => setMobileOpen(false)}
                className={mobileNavLinkClasses('settings')}
              >
                <Settings className="w-[18px] h-[18px]" />
                <span className="text-sm">Settings</span>
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Desktop sidebar */}
      <aside className="hidden md:flex flex-col items-center w-14 h-screen bg-bg-secondary shrink-0">
        {/* Logo */}
        <Link to="/" className="flex items-center justify-center h-12 w-full mb-2">
          <img src="/meridian-logo.png" alt="Meridian" className="w-6 h-6" />
        </Link>

        {/* Main nav icons */}
        <nav className="flex-1 flex flex-col items-center gap-1 px-1.5">
          {navItems.map(({ label, icon: Icon, path, section }) => {
            return (
              <Link
                key={section}
                to={path}
                title={label}
                className={navLinkClasses(section)}
              >
                <Icon className="w-[18px] h-[18px]" />
                {/* Tooltip */}
                <span className="absolute left-full ml-2 px-2 py-1 text-xs font-medium text-text-primary bg-bg-tertiary rounded-md opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity whitespace-nowrap z-50">
                  {label}
                </span>
              </Link>
            );
          })}
        </nav>

        {/* Settings at bottom */}
        <div className="pb-3 px-1.5">
          <Link
            to="/settings"
            title="Settings"
            className={navLinkClasses('settings')}
          >
            <Settings className="w-[18px] h-[18px]" />
            <span className="absolute left-full ml-2 px-2 py-1 text-xs font-medium text-text-primary bg-bg-tertiary rounded-md opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity whitespace-nowrap z-50">
              Settings
            </span>
          </Link>
        </div>
      </aside>
    </>
  );
}
